export const GEOMETRY_TYPE = {
  POINT: 'Point',
  POLYGON: 'Polygon',
  LINE: 'LineString'
};

export const MAPS_TAB = {
  LIVESTOCK: 'livestock',
  FARM: 'farms',
  GEOFENCE: 'pastures',
  SITE: 'sites'
};

export const DEFAULT_TAB = MAPS_TAB.LIVESTOCK;
